import React, {useState} from "react"
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {FlightStepType} from "components/shared/enums/global-enums.tsx";
import { useTranslation } from 'react-i18next';
import useStore from 'store/store'
import {generateTimeSlots, dateInFormat} from 'utils/helperFunctions'

import './DateTime.scss'

export default function DateTimeComp({typeFor, flightRecord}){
  const {t} = useTranslation();
  const bookingDetail = flightRecord.booking_detail;
  const [cDT, ] = useState(bookingDetail[typeFor+"_at"]);

  let verb, verb2;
  if (typeFor === FlightStepType.COLLECTION){
    verb = "check-in";
    verb2 = "departure";
  }else{
    verb = "deliver";
    verb2 = "arrival";
  }

  let modifiedDate = dateInFormat(flightRecord[verb2+"_at"], flightRecord[verb2+"_timezone"], null);
  // console.log(modifiedDate);
  if (modifiedDate.hour < 17) {
    modifiedDate = modifiedDate.minus({ days: 1 });
  }

  // Get times
  let dateTimes = generateTimeSlots(modifiedDate)

  return (
    <>
      <Box className={`dt-container col-modifier ${typeFor}`} >
        <Grid>
          <Grid className="">
            <span className="accent2-color para1 font-1-medium">{t("When")}</span>
            <span className="accent2-color para1 font-1-medium">{t(` would you like to ${verb}?`)}</span>
          </Grid>
          <div className="v-space-7"></div>
          <TimesComponent flightRecord={flightRecord} currentDate={cDT}  typeFor={typeFor}  dateTimes={dateTimes} verb2={verb2}/>
          <div className="v-space-5"></div>
        </Grid>
      </Box>

    </>
    )
}


const TimesComponent = ({currentDate, typeFor, dateTimes, flightRecord, verb2}) => {
  const storeActions = useStore((state)=> state.actions);
  
  const offset = dateInFormat(null, flightRecord[verb2+"_timezone"], "ZZ");

  currentDate = dateInFormat(currentDate, flightRecord[verb2+"_timezone"], "yyyy-MM-dd HH:mm "+offset)
  return (
      <Grid className="d-f fd-r jc-sa">
        <select defaultValue={currentDate} className="custom-time-picker w-100 c-txt" onClick={(e)=>storeActions.setItemValue(flightRecord, e.target.value, typeFor+"_at", "Date")}>
          {dateTimes.map((dateTime, key)=>{
            let date = dateTime.toFormat("MMM dd HH:mm")
            return (<option key={key} value={dateTime.toFormat("yyyy-MM-dd HH:mm "+offset)}>{date}</option>)
          })}  
        </select>

      </Grid>
    )
}